import React, { useEffect, useState } from "react";

import "./index.scss";

export default function CountInput({
                                     initialCount,
                                     handleChange,
                                     maxCount = 999,
                                     disabled,
                                     minCount = 0,
                                     bordered
                                   }) {
  const [count, setCount] = useState(initialCount ?? minCount);

  const handleUp = () => {
    if (disabled || count >= maxCount) {
      return;
    }
    setCount(count + 1);
    handleChange(count + 1);
  };

  const handleDown = () => {
    if (disabled || count <= minCount) {
      return;
    }
    setCount(count - 1);
    handleChange(count - 1);
  };

  useEffect(() => {
    setCount(initialCount);
  }, [initialCount]);

  const handleInput = (e) => {
    const newValue = parseInt(e.target.textContent) || minCount;
    setCount(newValue);
    handleChange(newValue);
  };

  const handleKeyDown = (e) => {
    // Handle Enter key press
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior (e.g., new line)
      e.target.blur(); // Remove focus from contentEditable element
      handleInput(e); // Call handleInput to update the count
    }
  };

  const handleKeyPress = (e) => {
    // Allow only numbers and Enter key
    const isNumberKey = /^\d$/.test(e.key);
    if (!isNumberKey && e.key !== "Enter") {
      e.preventDefault();
    }
  };

  return (
    <div className="count-input" style={{border: bordered ? '1px solid #EAEAEA' : "none"}}>
      <div
        suppressContentEditableWarning={true}
        className={`count-input__number`}
        contentEditable={!disabled} // Make content editable based on disabled prop
        onBlur={handleInput}
        onKeyDown={handleKeyDown}
        onKeyPress={handleKeyPress}
      >
        {count}
      </div>
      <div className="count-input__btns">
        <div
          className={`count-input__up ${
            count >= maxCount || disabled ? "disabled" : ""
          }`}
        >
          <img onClick={handleUp} src="/assets/icons/up-count.svg" alt="up" />
        </div>
        <div
          className={`count-input__down ${
            count <= 1 || disabled ? "disabled" : ""
          }`}
        >
          <img
            onClick={handleDown}
            src="/assets/icons/down-count.svg"
            alt="down"
          />
        </div>
      </div>
    </div>
  );
}
